import { useGetUser } from '@queries/users/useGetUser';

export function useIsInternalUser(): boolean {
  const { data: user } = useGetUser();

  return user?.type === 'INTERNAL';
}
